export default __webpack_public_path__ + "static/logo-13-11b280e80b180fe2c610788e812febd6.webp";